import React from "react";
import { DragDropContext } from 'react-beautiful-dnd';

const SarasDnDProvider = (props)=>{
    const { children, onDragEnd, ...restProps } = props;

    return (
        <DragDropContext onDragEnd={onDragEnd} {...restProps}>
            {children}
        </DragDropContext>
    )
}

export default SarasDnDProvider;
